import { render, staticRenderFns } from "./FerplastLogo.vue?vue&type=template&id=ff407250&scoped=true&"
var script = {}
import style0 from "./FerplastLogo.vue?vue&type=style&index=0&id=ff407250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff407250",
  null
  
)

export default component.exports